import { render, staticRenderFns } from "./coupon-restrictions-summary.vue?vue&type=template&id=7eec9c41&"
import script from "./coupon-restrictions-summary.vue?vue&type=script&lang=js&"
export * from "./coupon-restrictions-summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports